import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import { PlayerMode, selectPlayer } from "../../../features/player/playerSlice";
import { selectTheme, ThemeMode } from "../../../features/theme/themeSlice";

type HeaderIcon = {
  id: number;
  ico: string;
  label: string;
  enabled: boolean;
  route: string;
  visibleweb: boolean;
  visiblekiosk: boolean;
  showLabel: boolean;
};

const HeaderIcons: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const player = useAppSelector(selectPlayer);
  const location = useLocation();

  const icons: Array<HeaderIcon> = [
    {
      id: 3,
      ico: "ico_sport.png",
      label: "Movimenti",
      enabled: true,
      route: "kioskadmin/movimenti",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: true,
    },
    {
      id: 4,
      ico: "ico_sportlive.png",
      label: "scommesse",
      enabled: true,
      route: "kioskadmin/scommesse",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: true,
    },
    {
      id: 5,
      ico: "ico_sportlive.png",
      label: "Exit",
      enabled: true,
      route: "kiosk",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: true,
    },
  ];

  return (
    <div className="d-nav-icons d-flex f-row">
      {icons.map((ico, i) => {
        return ico.visibleweb ? (
          <div
            key={`ico-${ico.label}`}
            className={`pointer text-center d-header-icon admin ${
              location.pathname.split("/")[1] === ico.route ? "active" : ""
            }`}
            onClick={() => {
              if (ico.enabled) navigate(ico.route);
            }}
            title={ico.label}
          >
            <br />
            {ico.showLabel && <span className="icons-label">{ico.label}</span>}
          </div>
        ) : (
          ""
        );
      })}
    </div>
  );
};

export default HeaderIcons;
